function getReleaseHostname() {
  const { hostname } = window.location;

  // Special case for "erpweb-prepublish.yishouapp.com"
  if (hostname === "erpweb-prepublish.yishouapp.com") {
    return "erpprepublish";
  }
  // Special case for "erpweb-stable.yishouapp.com"
  if (hostname === "erpweb-stable.yishouapp.com") {
    return "erp-stable";
  }

  // Use a regular expression to match the pattern and capture the number, ignoring the domain suffix
  const releasePattern = /^erpweb-release-(\d+)\.yishouapp\.com$/;
  const featPattern = /^erpweb-feat-(\d+)\.yishouapp\.com$/;

  // If the pattern matches, replace 'erpweb' with 'erp' and only use the number captured
  if (releasePattern.test(hostname)) {
    return hostname.replace(releasePattern, "erp-release-$1");
  }
  if (featPattern.test(hostname)) {
    return hostname.replace(featPattern, "erp-feat-$1");
  }
  // host name fallbacks to erp-stable.yishouapp.com

  // If the hostname doesn't match the desired pattern, you might want to return the original hostname
  // or handle it differently depending on your use case.
  return "erp-stable";
}

export default getReleaseHostname;



// WEBPACK FOOTER //
// ./src/utils/getReleaseHostname.js